module.exports = "./assets/assets/政府采购质疑和投诉办法.2d391677.docx";